/** @jsxImportSource @emotion/react */
// TODO - The second time you use the mutation the screen doesn't refresh

import React from "react";
import { useParams } from "react-router-dom";
import { Link, Button, Label, Table } from "atoms";
import { EntityNotFound } from "features/layouts";
import { Head } from "features/misc";
import { useTicketById, useTicketUpdate } from "features/tickets";
import { formatDate } from "utils/date";
import { useReviewable } from "features/reviewable/api/useReviewable";

const css = {
  button: {
    margin: "4px",
  },
  textarea: {
    width: "500px",
    height: "100px",
  },
};

function AdminTicketDetails() {
  const { ticketId } = useParams() as { ticketId: string };
  const [status, setStatus] = React.useState<string>("New");
  const [notes, setNotes] = React.useState<string>("");

  const {
    data: ticket,
    isLoading: isTicketLoading,
    isError: isTicketError,
    error,
  } = useTicketById(ticketId);

  const {
    data: reviewable,
    isLoading: isReviewableLoading,
    isError: isReviewableError,
  } = useReviewable(ticket?.reviewableType ?? "", ticket?.reviewableId ?? "");

  const updateTicket = useTicketUpdate(ticket?.id, status, notes);

  const hasHistory = ticket && ticket.history.length > 0;

  React.useEffect(() => {
    if (ticket) {
      setStatus(ticket.status);
    }
  }, [ticket, setStatus]);

  // TODO - Not Refreshing React
  const onSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    if (ticket && status) {
      updateTicket();
    }
  };

  if (isTicketError || isReviewableError) {
    return error?.status === 404 ? (
      <EntityNotFound
        type="ticket"
        linkText="View Tickets"
        linkTo="/qa/tickets"
      />
    ) : (
      <main>
        <em>Error loading ticket</em>
      </main>
    );
  }
  if (isTicketLoading || isReviewableLoading || !ticket || !reviewable) {
    return (
      <main>
        <em>Loading...</em>
      </main>
    );
  }
  return (
    <main>
      <Head title={`${ticketId} | Tickets`} />

      <h1>
        Ticket #{ticket.ticketNumber} For: {reviewable.name}
      </h1>
      <p>
        <strong>Reported By: </strong>
        {ticket.createdByUserName} [{ticket.createdByUserId}]
        <br />
        <strong>Category: </strong>
        {ticket.category}
        <br />
        <strong>Status: </strong>
        {ticket.status}
      </p>

      <p>
        <strong>Notes: </strong>
        <br />
        {ticket.notes}
      </p>

      <Link to={`/${reviewable.type.toLowerCase()}s/${reviewable.id}/edit`}>
        Edit {reviewable.type.toLowerCase()}
      </Link>

      {hasHistory ? (
        <>
          <h2>Ticket History</h2>
          <Table>
            <thead>
              <tr>
                <th>Reviewer</th>
                <th>Date</th>
                <th>New Status</th>
                <th>Review Notes</th>
              </tr>
            </thead>
            <tbody>
              {ticket.history.map((row) => (
                <tr key={row.timestamp}>
                  <td>{row.userName}</td>
                  <td>{formatDate(row.timestamp)}</td>
                  <td>{row.status}</td>
                  <td>{row.notes}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      ) : (
        <hr />
      )}
      <h2>Update Ticket</h2>
      <p>Change status...</p>
      <ul>
        <li>
          <strong>Open:</strong> claim and work on this ticket.
        </li>
        <li>
          <strong>New:</strong> let someone else work on it.
        </li>
        <li>
          <strong>Closed:</strong> finished.
        </li>
      </ul>
      <form onSubmit={onSubmit}>
        <p>
          <Label>
            Status
            <br />
            <select value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="New">New</option>
              <option value="Open">Open</option>
              <option value="Closed">Closed</option>
            </select>
          </Label>
        </p>
        <p>
          <Label>
            Notes
            <br />
            <textarea
              value={notes}
              css={css.textarea}
              onChange={(e) => setNotes(e.target.value)}
            />
          </Label>
        </p>
        <p>
          <Button css={css.button} type="submit">
            Submit
          </Button>
        </p>
      </form>
    </main>
  );
}
export { AdminTicketDetails };
